export const DASHBOARD_REFRESH_MS = 1000 * 2;
export const GOOGLE_MAPS_API_KEY = "AIzaSyAXkPEo7hXNNKR-hLDcvRssXLZatAKrTEM";
export const PARAMS = {
  mode: {
    mode: "mode",
    login: "login",
    signup: "signup",
  },
  theme:{
    light: "theme-light",
    dark: "theme-dark",
    ocean: "theme-ocean",
    forest: "theme-forest",
    sunset: "theme-sunset",
    royal: "theme-royal",
    slate: "theme-slate",
    midnight: "theme-midnight",
    ember: "theme-ember",
    arctic: "theme-arctic",
    copper: "theme-copper",
    lavender: "theme-lavender",
    emerald: "theme-emerald",
    carbon: "theme-carbon",
    wine: "theme-wine",
    sand: "theme-sand",
    cobalt: "theme-cobalt",
  },
};

export const COUNTRY_COORDS = {
  bolivia:{
    gpsx: -16.290154,
    gpsy: -63.588653
  }
}
